// Service URLs held by a backend configuration, in the order they are shown in the form and table
export const SERVICE_FIELDS = [
  {name: "conversationLoggerApi", label: "Conversation Logger API", placeholder: "https://logger.example.com/api"},
  {name: "chatbotApi", label: "Chatbot API", placeholder: "https://chatbot.example.com/api"},
  {name: "mcpRegistry", label: "MCP Registry", placeholder: "https://mcp.example.com/registry"},
  {name: "initiateCallApi", label: "Initiate Call API", placeholder: "https://calls.example.com/api/initiate"},
  {name: "knowledgeManagerApi", label: "Knowledge Manager API", placeholder: "https://knowledge.example.com/api"},
];
